export default __webpack_public_path__ + "static/media/bottom.169cff77.svg";